import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import React from "react";
import { Button, Grid } from "@mui/material";
import { createCompany } from '../../../app/slices/companiesSlice';
import { useNavigate } from "react-router-dom";

function CompanyInfoSection({ model }) {
    const { t } = useTranslation('CompanyCreateScreen', { keyPrefix: 'Submit' });
    const { t: link} = useTranslation('Pages');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = () => {
        dispatch(createCompany(false)).then(({ payload }) => {
            if (payload && payload.data) {
                navigate(link('companyLink') + payload.data.id);
            } else {
                alert(t('apiError'));
            }
        });
    }

    return (
        <Grid container spacing={2} style={{marginTop: '15px', padding: '25px'}}>
            <Grid item md={3} />
            <Grid item md={8}>
                <Button
                    className="fk-button fk-button--primary"
                    fullWidth
                    onClick={handleSubmit}
                >
                    {t('button')}
                </Button>
            </Grid>
            <Grid item md={1} />
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    model: state.companies.company
});

const actions = {
};

export default connect(mapStateToProps, actions)(CompanyInfoSection);